import React, { Component } from 'react'
import get from 'lodash.get'
import { CtaBtn } from '../../../components'
import { Constants } from '@sukiai/components'
import InputMask from 'react-input-mask'
import {
  hasMinimumChar,
  hasNumber,
  hasUpperCase,
  hasLowerCase,
  doesNotContainUsername,
  isValidEmail,
  snakeCapsToEnglish
} from '@sukiai/utils'
import {
  Form,
  Select,
  Input,
  InputGroup,
  InputContainer,
  InputErrorIcon,
  EMRSupportText
} from '../components/styles/form'
import AgreementCheckbox from '../components/AgreementCheckbox'
import { EMR_SUPPORT, EMR_TYPE } from '../constants'
const { SPECIALTY_TYPE, TIMEZONES } = Constants
const SPECIALTIES_ARR = Object.keys(SPECIALTY_TYPE)

class OnboardForm extends Component {
  state = {
    isPasswordHidden: true,

    firstName: this.props.initialValues.firstName,
    lastName: this.props.initialValues.lastName,
    suffix: this.props.initialValues.suffix,
    practiceName: this.props.initialValues.practiceName,
    phoneNumber: this.props.initialValues.phoneNumber,
    specialties: [''],
    timezone: '',
    emr: '',
    email: this.props.initialValues.email,
    password: '',
    confirmPassword: '',

    touched: {
      firstName: false,
      lastName: false,
      practiceName: false,
      phoneNumber: false,
      specialties: false,
      emr: false,
      email: false,
      timezone: false,
      password: false,
      confirmPassword: false
    }
  }

  touchField = field => e => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handlePhoneChange = e => {
    // remove mask, remove leading 1 -- kinda hacky
    const val = e.target.value.replace(/[^\d]/g, '')
    this.setState({ [e.target.name]: val })
  }

  onSubmitClick = e => {
    // touch all inputs for validation
    const touched = { ...this.state.touched }
    Object.keys(touched).forEach(field => {
      touched[field] = true
    })
    this.setState({ touched })

    // shake on error
    const errors = this.checkFieldErrors()
    const isInvalid = Object.keys(errors).some(x => errors[x])

    if (isInvalid) {
      this.setSubmissionBtnErr()
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    const { handleFormCompletion } = this.props

    const {
      firstName,
      lastName,
      suffix,
      phoneNumber,
      specialties,
      timezone,
      password,
      emr,
      email,
      practiceName
    } = this.state

    // do final check
    const errors = this.checkFieldErrors()
    const isInvalid = Object.keys(errors).some(x => errors[x])

    if (isInvalid) {
      this.setSubmissionBtnErr()

      console.debug('ERROR OBJECT' + errors)
      return
    }

    // dedupe + sort specialties array
    const filteredSpecialties = [...new Set(specialties)].filter(s => !!s)

    // get emr value
    const emrValue = get(EMR_TYPE.find(e => emr === e.name), 'value', 'UNKNOWN')

    // package for api
    const formValues = {
      firstName,
      lastName,
      suffix,
      phoneNumber,
      specialties: filteredSpecialties,
      timezone,
      password,
      emr: emrValue,
      email,
      practiceName
    }

    handleFormCompletion(formValues)
  }

  setSubmissionBtnErr = () => {
    // set error then reset
    this.setState({ onSubmissionError: true }, () => {
      setTimeout(() => {
        this.setState({ onSubmissionError: false })
      }, 1000)
    })
  }

  checkFieldErrors = () => {
    const {
      phoneNumber,
      practiceName,
      timezone,
      emr,
      email
    } = this.state

    // true means invalid
    return {
      practiceName: practiceName.trim().length === 0,
      phoneNumber: phoneNumber.trim().length === 0,
      timezone: timezone.trim().length === 0,
      emr: emr.trim().length === 0,
      email: !isValidEmail(email)
    }
  }

  checkPasswordErrors = () => {
    const { email, password } = this.state

    // true means invalid
    return {
      hasUpperCase: !hasUpperCase(password),
      hasLowerCase: !hasLowerCase(password),
      hasNumber: !hasNumber(password),
      hasMinimumChar: !hasMinimumChar(password),
      doesNotContainUsername: !doesNotContainUsername(password, email)
    }
  }

  addSpecialtyInput = e => {
    e.preventDefault()
    const specialties = [...this.state.specialties]
    specialties.push('')
    this.setState({ specialties })
  }

  handleSpecialtyChange = (e, index) => {
    e.preventDefault()
    const value = e.target.value
    const specialties = [...this.state.specialties]
    specialties[index] = value

    this.setState({ specialties })
  }

  renderSpecialties = () => {
    const { specialties } = this.state

    return specialties.map((specialty, i) => (
      <Select
        key={i}
        name='specialties'
        value={specialty}
        onChange={e => this.handleSpecialtyChange(e, i)}
      >
        <option value=''>Select Specialty</option>
        {SPECIALTIES_ARR.map(s => (
          <option key={s} value={s}>
            {snakeCapsToEnglish(s)}
          </option>
        ))}
      </Select>
    ))
  }

  renderTimezoneOptions = () => {
    return TIMEZONES.map(timezone => (
      <option key={timezone.value} value={timezone.value}>
        {timezone.name}
      </option>
    ))
  }

  renderEMRSupport = () => {
    const { emr } = this.state

    const currentEMR = EMR_TYPE.find(e => emr === e.name)
    const currentEMRName = get(currentEMR, 'name')
    const currentEMRSupport = get(currentEMR, 'support')

    switch (currentEMRSupport) {
      case EMR_SUPPORT.IS_SUPPORTED:
        return (
          <EMRSupportText>
            Integrating with {currentEMRName} only takes a few days. Our team will contact you with details. In the meantime, you can get started without integration.
          </EMRSupportText>
        )
      case EMR_SUPPORT.WILL_SUPPORT:
        return (
          <EMRSupportText>
            Integrating with {currentEMRName} can take a while. Our team will contact you with details. In the meantime, you can get started without integration.
          </EMRSupportText>
        )

      case EMR_SUPPORT.NOT_SUPPORTED:
        // special case for other
        if (currentEMRName === 'Other') {
          return (<EMRSupportText>Suki integrates with a few select EMRs. You can get started without integration.</EMRSupportText>)
        } else {
          return (<EMRSupportText>Suki does not integrate with {currentEMRName}. You can still get started without integration.</EMRSupportText>)
        }
      default:
        return null
    }
  }

  renderEMRSelect = () => {
    const { emr } = this.state
    // EMR_TYPE
    return (
      <Select
        name='emr'
        value={emr}
        onChange={this.handleChange}
        required
      >
        <option value=''>Select EMR</option>
        {EMR_TYPE.map(e => (
          <option key={e.name} value={e.name}>
            {e.name}
          </option>
        ))}
      </Select>

    )
  }

  render () {
    // need to disable practiceName, email if not from gcp
    const { isFormLoading } = this.props
    const {
      touched,
      practiceName,
      phoneNumber,
      timezone,
      email
    } = this.state

    const errors = this.checkFieldErrors()
    const isFieldError = field => {
      const error = errors[field]
      const shouldShow = touched[field]

      return error ? shouldShow : false
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <h2>Suki registration </h2>

        <InputContainer>
          <Input
            type='text'
            name='practiceName'
            placeholder='Practice Name'
            value={practiceName}
            onChange={this.handleChange}
            onBlur={this.touchField('practiceName')}
            autoComplete='none'
            required
          />
          {isFieldError('practiceName') && <InputErrorIcon />}
        </InputContainer>

        <InputContainer>
          <InputMask
            className='onboard-input'
            type='tel'
            name='phoneNumber'
            placeholder='Phone Number'
            defaultValue={phoneNumber}
            onChange={this.handlePhoneChange}
            onBlur={this.touchField('phoneNumber')}
            mask='+1 (999) 999-9999'
            required
          />
          {isFieldError('phoneNumber') && <InputErrorIcon />}
        </InputContainer>

        <Select
          name='timezone'
          value={timezone}
          onChange={this.handleChange}
          required
          error={isFieldError('timezone').toString()}
        >
          <option value=''>Select Timezone</option>
          {this.renderTimezoneOptions()}
        </Select>

        {this.renderEMRSelect()}
        {this.renderEMRSupport()}

        <InputGroup>
          <Input
            type='email'
            name='email'
            placeholder='email'
            value={email}
            onChange={this.handleChange}
            onBlur={this.touchField('email')}
            autoComplete='none'
          />
          {isFieldError('email') && <InputErrorIcon />}
        </InputGroup>

        <AgreementCheckbox />

        <CtaBtn handleClick={this.onSubmitClick} isLoading={isFormLoading} error={this.state.onSubmissionError}>
          Register
        </CtaBtn>
      </Form>
    )
  }
}

export default OnboardForm
